import * as images from "@/components/images/Images";
import { ServicePlanCardProps } from "@/components/screen/global-components/services/ServicePlanCard";
import { ROUTES } from "@/constants";

const useCasesPricingPlansContent = {
  title: "Online document translation services",
  description:
    "Never compromise on speed, precision, or cost using high quality human translators accessed through a user-friendly platform supported by AI to streamline order and delivery in 24-hours or less",
} as const;

const useCasesPricingPlansCards: ServicePlanCardProps[] = [
  {
    title: "Translate standard documents",
    image: images.solar_buildings1,
    price: "<span>$0.10</span>&nbsp;per word",
    description:
      "Our most basic offering for straight forward translation projects that don’t require a certificate or unique translator specialization. Our intelligent platform matches your project to an expert translator experienced in your language pair and use case for average turnaround in 24-hours or less, with an expedited option available for an additional $10 at checkout.",
    mainButton: "Start Order",
    mainButtonLink: ROUTES.startOrder,
    secondaryButton: "Learn more",
    secondaryButtonLink: ROUTES.standardTranslation,
  },
  {
    title: "Translate official documents",
    image: images.solar_buildings2,
    price: "<span>$24.50</span>&nbsp;/ page",
    description:
      "This plan is for when you might require a certified or notarized translation to have your translation accepted for official purposes. Receive a word-for-word translation from an accredited translator, which comes with a dated, and signed certification statement as required by universities, courts, and government agencies.",
    mainButton: "Start Order",
    mainButtonLink: ROUTES.startOrder,
    secondaryButton: "Learn more",
    secondaryButtonLink: ROUTES.certifiedTranslation,
  },
  {
    title: "Enterprise translation services",
    image: images.solar_buildings3,
    price: "Pricing on request",
    description:
      "Best for businesses with complex, unique, or recurring translation needs. Custom-fit our document translation services to your business. Seamlessly order and deliver any complexity or volume of translations through our user-friendly platform.",
    mainButton: "Get a quote",
    mainButtonLink: ROUTES.getQuote,
    secondaryButton: "Learn more",
    secondaryButtonLink: ROUTES.enterpriseTranslation,
    highlight: "accent",
  },
];

export const useCasesPricingPlansData = {
  ...useCasesPricingPlansContent,
  cards: useCasesPricingPlansCards,
};
